import { EMPLOYEES_SYNC_INTERVAL_MS, EMPLOYEES_SYNC_MAX_INTERVAL_MS } from '../hooks/appDefaults';

/**
 * Calcula intervalo de polling com backoff exponencial após falhas consecutivas.
 * @param failCount - Número de falhas seguidas (>= 1)
 * @returns Delay em ms, limitado ao máximo configurado
 */
export function computeSyncBackoffMs(failCount: number): number {
  const safeFails = Math.max(1, failCount);
  const delay = EMPLOYEES_SYNC_INTERVAL_MS * 2 ** (safeFails - 1);
  return Math.min(delay, EMPLOYEES_SYNC_MAX_INTERVAL_MS);
}
